export { default, getStaticPaths, getStaticProps } from 'src/pages/Courses/pages/Course'
